<template>
<div class="home">
    <img src="../assets/1.png" width="100%" />
    <div class="menu">
        <img src="../assets/2.png" />
        <ul class="list">
            <li :class="{selected:currentSelect==1,yellow:currentSelect==1}" @click="SelectIndex(1)"><img :src="pic1" />
                <p>发起申请</p>
            </li>
            <li :class="{selected:currentSelect==2,red:currentSelect==2}" @click="SelectIndex(2)"><img :src="pic2" />
                <p>我的申请</p>
            </li>
            <li :class="{selected:currentSelect==3,blue:currentSelect==3}" @click="SelectIndex(3)"><img :src="pic3" />
                <p>待我审批</p>
            </li>
            <div class="clear"></div>
        </ul>
        <div class="clear"></div>
        <div class="list2" v-if="currentSelect==1">
            <ul style="display: flex; flex-wrap: wrap;">
                <li><a href="/#/gsjy_create" style="color:#fff"><img src="@/assets/7.png" />
                        <p>工商教育<br>业务线<br>合同审批</p>
                    </a>
                </li>
                <li><a href="/#/yl_create" style="color:#fff"><img src="@/assets/26.png" />
                        <p>医疗业务线<br>合同审批</p>
                    </a>
                </li>
                <li><a href="/#/pc_create" style="color:#fff"><img src="@/assets/10_1.png" />
                        <p>餐饮业务线<br>合同审批</p>
                    </a>
                </li>
                <!-- <li><a href="/#/create?type=1" style="color:#fff"><img src="@/assets/7.png" />
                        <p>业务线<br>合同审批</p>
                    </a>
                </li> -->
                <li><a href="/#/zn_create" style="color:#fff"><img src="@/assets/8.png" />
                        <p>职能<br>合同审批</p>
                    </a>
                </li>
                <li><a href="/#/gyl_create" style="color:#fff"><img src="@/assets/9.png" />
                        <p>供应链<br>合同审批</p>
                    </a>
                </li>
                <li><a href="/#/rlwb_create" style="color:#fff"><img src="@/assets/10.png" />
                        <p>人力外包<br>合同审批</p>
                    </a>
                </li>
                <li><a href="/#/stamp_create" style="color:#fff"><img src="@/assets/33.png" />
                        <p>非协议类<br>用章申请</p>
                    </a>
                </li>
            </ul>
            <div class="clear"></div>
        </div>
        <div class="list2" v-if="currentSelect==2">
            <ul>
                <li><a @click="GoToList(1)" style="color:#fff"><img src="@/assets/28.png" />
                        <p>草稿箱</p>
                    </a>
                </li>
                <li><a @click="GoToList(2)" style="color:#fff"><img src="@/assets/16.png" />
                        <p>处理中</p>
                    </a>
                </li>
                <li><a @click="GoToList(6)" style="color:#fff"><img src="@/assets/30.png"/>
                        <p>已通过</p>
                    </a>
                </li>
                <li><a @click="GoToList(4)" style="color:#fff"><img src="@/assets/27.png" style="padding-top:0px" />
                        <p>已拒绝</p>
                    </a>
                </li>
                <li><a @click="GoToList(5)" style="color:#fff"><img src="@/assets/29.png" style="padding-top:10px" />
                        <p>已作废</p>
                    </a>
                </li>
                <li><a @click="GoToList(3)" style="color:#fff"><img src="@/assets/26.png" style="padding-top:10px" />
                        <p>已归档</p>
                    </a>
                </li>     
                <li><a href="/#/stamp_EntrustConfig" style="color:#fff"><img src="@/assets/34.png" style="padding-top:10px" />
                        <p>用章<br>委托人设置</p>
                    </a>
                </li>                
            </ul>
            <div class="clear"></div>
        </div>
        <div class="list2" v-if="currentSelect==3">
            <ul>
                <li><a @click="GoToApproveList(1)" style="color:#fff"><img src="@/assets/31.png" />
                        <p>待处理</p>
                    </a>
                </li>
                <li><a @click="GoToApproveList(2)" style="color:#fff"><img src="@/assets/32.png" />
                        <p>已处理</p>
                    </a>
                </li>
            </ul>
            <div class="clear"></div>
        </div>
    </div>
</div>
</template>

<script>
import icon3 from '@/assets/3.png'
import icon4 from '@/assets/4.png'
import icon5 from '@/assets/5.png'
import icon3_1 from '@/assets/3_1.png'
import icon4_1 from '@/assets/4_1.png'
import icon5_1 from '@/assets/5_1.png'
import {
    Toast,
    Indicator,
    MessageBox
} from 'mint-ui';
export default {
    name: 'Home',
    data() {
        return {
            iconList1: [icon3, icon4, icon5],
            iconList2: [icon3_1, icon4_1, icon5_1],
            pic1: icon3,
            pic2: icon4_1,
            pic3: icon5_1,
            currentSelect: 1,
            userInfo: {}
        };
    },
    mounted() {
        var that = this;
        that.getUserInfo();
    },
    methods: {
        getUserInfo() {
            var that = this;
            that.$axios
                .get("/api/User/GetUserInfo")
                .then(async (res) => {
                    if (res.data != null && res.data.isSuccess) {
                        that.userInfo = res.data.data;
                        sessionStorage.setItem("UserInfo", JSON.stringify(that.userInfo));
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        GoToList(index) {
            var that = this;
            that.$router.push({
                path: `/list?type=${index}`
            });
        },
        GoToApproveList(index) {
            var that = this;
            that.$router.push({
                path: `/approve_list?type=${index}`
            });
        },
        SelectIndex(index) {
            var that = this;
            that.currentSelect = index;
            if (that.currentSelect == 1) {
                that.pic1 = that.iconList1[0];
                that.pic2 = that.iconList2[1];
                that.pic3 = that.iconList2[2];
            } else if (that.currentSelect == 2) {
                that.pic1 = that.iconList2[0];
                that.pic2 = that.iconList1[1];
                that.pic3 = that.iconList2[2];
            } else if (that.currentSelect == 3) {
                that.pic1 = that.iconList2[0];
                that.pic2 = that.iconList2[1];
                that.pic3 = that.iconList1[2];
            }
        }
    }
}
</script>

<style scoped>
.selected {
    font-weight: bold;
}

.yellow {
    color: #ffc72c;
}

.red {
    color: #fe6064;
}

.blue {
    color: #9acaeb;
}
</style>
